import * as localDb from '../localDb';

export async function saveSettings (data) {
    try {
        await localDb.put('settings', 'custom', { id: 'custom', configuration: data }, false);
    } catch(error) {
        throw new Error (`Unable to save config: ${error.message}`)
    }
}